import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Devolucoes() {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5">Devoluções</Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>Página de controle de devoluções (placeholder).</Typography>
    </Box>
  );
}
